function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "Form_svg__2_a",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#7793FF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#D576F0"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "url(#Form_svg__2_a)",
  d: "M8 0h34a8 8 0 018 8v34a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8z"
}), React.createElement("g", {
  fill: "#FFF"
}, React.createElement("path", {
  d: "M19.727 13h.546c1.027 0 2.01.415 2.727 1.15A3.806 3.806 0 0125.727 13h.546a1.09 1.09 0 110 2.182h-.546c-.903 0-1.726.733-1.727 1.636v16.364c.001.903.824 1.635 1.727 1.636h.546a1.09 1.09 0 110 2.182h-.546A3.806 3.806 0 0123 35.85 3.806 3.806 0 0120.273 37h-.546a1.09 1.09 0 110-2.182h.546c.903 0 1.726-.733 1.727-1.636V16.818c-.001-.903-.824-1.635-1.727-1.636h-.546a1.09 1.09 0 110-2.182zM19 29c.602 0 1 .47 1 1s-.398 1-1 1h-5c-1.807 0-3-1.409-3-3v-6c0-1.591 1.193-3 3-3h5c.602 0 1 .47 1 1s-.398 1-1 1h-5c-.602 0-1 .47-1 1v6c0 .53.398 1 1 1h5z",
  opacity: 0.504
}), React.createElement("path", {
  d: "M38.5 18a1.5 1.5 0 011.5 1.5v11a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-11a1.5 1.5 0 011.5-1.5h11zm-1 10h-9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm-3-3h-6a.5.5 0 100 1h6a.5.5 0 100-1zm3-3h-9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm-5-2h-4a.5.5 0 100 1h4a.5.5 0 100-1z"
})));

var SvgForm = function SvgForm(props) {
  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

export default SvgForm;